var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAccessoryType
    ? _c(
        "section",
        {
          staticClass: "descriptionContainer",
          attrs: { id: "matchingEquipmentDetail" },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-block text-left descriptionButton",
              class: { collapsed: !_vm.isOpen },
              attrs: {
                "aria-expanded": _vm.isOpen ? "true" : "false",
                "aria-controls": "matchingEquipment",
                "aria-label": _vm.$translate(
                  "biokinderDesign::Template.itemAccessories"
                ),
                "click-count": "",
              },
              on: { click: _vm.toggleAccordion },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon-accessories",
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      x: "3",
                      y: "3",
                      width: "18",
                      height: "18",
                      rx: "2",
                      ry: "2",
                    },
                  }),
                  _c("line", {
                    attrs: { x1: "12", y1: "8", x2: "12", y2: "16" },
                  }),
                  _c("line", {
                    attrs: { x1: "8", y1: "12", x2: "16", y2: "12" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("biokinderDesign::Template.itemAccessories")
                  ),
                },
              }),
              _vm._v(" "),
              _c("i", { attrs: { "data-feather": "plus" } }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse mt-1",
              class: { show: _vm.isOpen },
              attrs: {
                id: "matchingEquipment",
                "aria-labelledby": "matchingEquipment",
                "data-parent": "#rightSide",
              },
            },
            [
              _vm.isLoading
                ? _c("loading-animation")
                : _vm.loadFailed
                ? _c("div", { staticClass: "descriptionContent" }, [
                    _vm._v(
                      "\n            Zubehör konnte nicht geladen werden.\n        "
                    ),
                  ])
                : _vm.renderedItems.length === 0
                ? _c("div", { staticClass: "descriptionContent" }, [
                    _vm._v("\n            Kein Zubehör vorhanden.\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.renderedItems, function (item) {
                return _c("category-item", {
                  key: item.variation.id,
                  attrs: {
                    "image-url-accessor": "urlSecondPreview",
                    "item-data": item,
                    "view-mode": "cart",
                    "decimal-count": _vm.decimalCount,
                  },
                })
              }),
            ],
            2
          ),
        ]
      )
    : _vm.shouldRenderCartCrossSelling
    ? _c(
        "section",
        { staticClass: "cartCrossSelling cross-selling-content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.isLoading
            ? _c("loading-animation")
            : _vm.loadFailed
            ? _c("div", { staticClass: "descriptionContent" }, [
                _vm._v(
                  "\n        Empfehlungen konnten nicht geladen werden.\n    "
                ),
              ])
            : _vm._l(_vm.renderedItems, function (item) {
                return _c("category-item", {
                  key: item.variation.id,
                  attrs: {
                    "image-url-accessor": "urlSecondPreview",
                    "item-data": item,
                    "view-mode": "cart",
                    "decimal-count": _vm.decimalCount,
                  },
                })
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", [_vm._v("Noch mehr entdecken ")]),
      _vm._v("Passend zu diesem Artikel"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }